import { render, staticRenderFns } from "./ShareToPay.vue?vue&type=template&id=85e0371a&scoped=true"
import script from "./ShareToPay.vue?vue&type=script&lang=ts"
export * from "./ShareToPay.vue?vue&type=script&lang=ts"
import style0 from "./ShareToPay.vue?vue&type=style&index=0&id=85e0371a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e0371a",
  null
  
)

export default component.exports